import React, {useEffect, useState} from 'react';
import { withStyles } from "@mui/styles";
import {Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography} from '@mui/material';
import {connect} from "trim-redux";
import {useTranslation} from "react-i18next";
import {Close} from "@mui/icons-material";
import Button from "@mui/material/Button";
import {useLocation, useNavigate} from "react-router-dom";
import {Styles} from "../../../../../config/design/styles";
import {Trash,Plus} from "lucide-react";
import RayaField from "../../../../components/elements/fields/RayaField";
import axios from "axios";
import {defaultVariables} from "../../../../../config";
import {updateRedux} from "../../../../../config/Security";
import {translate} from "../../../../../config/lang";
import LoadingButton from "../../../../components/elements/LoadingButton";
import Grid from "@mui/material/Grid2";
import SubTitle from "../../../../components/elements/SubTitle"; // Import useMediaQuery and Theme

function AddDiscountCodeDialogButton({setCode }) {
    const { t } = useTranslation();
    const [open,setOpen] = useState(false);
    const [loading,setLoading] = useState(false);
    const [discountCode,setDiscountCode] = useState(null);
    const [field,setField] = useState("");
    const [error,setError] = useState("");
    const navigation = useNavigate();

    const handleCode = (code) => {
        setDiscountCode(code);
        setCode(code);
        setOpen(false);
        setField("");
        setError("");
    }
    const handleField = (val) => {
        setField(val);
        setError("");
    }
    const handleRequest = async () => {
        if(!!field){
            setLoading(true);
            const data = new FormData();
            data.append('discount_code', field);
            const loginToken = localStorage.getItem('ACT');
            const config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            axios.post(`${defaultVariables.url}/discount-codes/check`,data,config)
                .then(response => {
                    setLoading(false);
                    handleCode(response.data);
                })
                .catch(error => {
                    console.error("Error fetching item data:", error);
                    setError(t('wrongDiscountCode'))
                    setLoading(false);
                });
        }

    };
    return (
        <>
            {
                !!discountCode ?
                <IconButton
                    onClick={() => handleCode(null)}
                >
                    <Trash className="lucide-icon-primary"/>
                </IconButton> :
                    <Button
                        variant="outlined"
                        onClick={() => setOpen(true)}
                        startIcon={<Plus/>}
                    >
                        {t('discountCodeDesc')}

                    </Button>
            }
            <Dialog  open={open} onClose={() => setOpen(false)} fullWidth maxWidth="xs">
                <DialogTitle>
                    <SubTitle className="dialog-title" align="left">
                            {t('discountCode')}
                    </SubTitle>
                    <IconButton
                        onClick={() => setOpen(false)}
                        style={{position:"absolute",right:15,top:15}}
                        size="small"
                    >
                        <Close className="lucide-icon"/>
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item size={12}>
                            <Typography>{t('discountCodeDesc')}:</Typography>
                        </Grid>
                        <Grid item size={12}>
                            <RayaField
                                fullWidth
                                label={t("discountCode")}
                                variant="outlined"
                                value={field}
                                onChange={(e) => handleField(e.target.value)}
                                error={!!error}
                                helperText={error}
                                autoFocus
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions style={{justifyContent:"center"}}>
                    <LoadingButton
                        type="submit"
                        variant="contained"
                        color="primary"
                        style={{ width: "100%" }}
                        loading={loading}
                        onClick={handleRequest}
                    >
                        {t('checkCode')}
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </>

    );
}
const mapStateToProps = (state) => ({
    isAuth: state.isAuth,
});

export default withStyles(Styles)(connect(mapStateToProps)(AddDiscountCodeDialogButton));
